import Image from 'next/image';
import { TextMediaProps } from '@/components/_rebrand/TextMedia';
import { FeatureBullet, FeatureImage, FeatureToDisplay } from './AlternatingFeatures.types';

export const mapBulletsToFeatureBullets = (bullets: FeatureBullet[]): TextMediaProps['features'][number]['bullets'] => {
  return bullets.map((bullet) => ({
    feature: bullet.bulletText,
  }));
};

export const createFeatureImage = (image: FeatureImage | FeatureImage[]): TextMediaProps['features'][number]['featureImage'] => {
  const imageData = Array.isArray(image) ? image[0] : image;

  if (!imageData) return null;
  return <Image src={imageData.url} width={imageData.width} height={imageData.height} alt={imageData.title} />;
};

export const mapFeaturesToTextMediaFeatures = (features: FeatureToDisplay[]): TextMediaProps['features'] => {
  return features.map((feature) => ({
    title: feature.headline,
    featureImage: createFeatureImage(feature.image),
    bullets: mapBulletsToFeatureBullets(feature.bullets),
  }));
};
